import React, { Component } from "react";
import "../../css/FilterOption.css";
import { connect } from "react-redux";
import { chosenFilter } from "../../models";

class FitlerOption extends Component {
  chooseFilter = async data => {
    const {
      chosenFilterList,
      addFilter,
      removeFilter,
      keywords,
      activeSortBy
    } = this.props;
    const found = chosenFilterList.findIndex(item => item.code === data.code);
    if (found === -1) {
      // 新增篩選條件到陣列中
      await addFilter(data, keywords, activeSortBy);
    } else {
      // 移除陣列中的自己;
      removeFilter(data, keywords, activeSortBy);
    }
  };

  hadSelected = item => {
    // 判斷此條件是否已被選取
    const found = this.props.chosenFilterList.findIndex(
      data => data.code === item.code
    );
    const selected = found === -1 ? false : true;
    return selected;
  };

  render() {
    const { data } = this.props;
    return (
      <div>
        <div className={`filter-mobile-option`}>
          <div>{data.name}</div>
          <div
            className={`filter-mobile-option-label ${
              this.hadSelected(data) ? "option-checked" : ""
            }`}
            onClick={this.chooseFilter.bind(this, data)}
          ></div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    chosenFilterList: state.chosenFilter.chosenFilterList,
    activeSortBy: state.sortByFilter.activeSortBy
  };
};

const mapDispatchToProps = () => {
  return {
    addFilter: (data, keywords, activeSortBy) =>
      chosenFilter.actions.addFilter(data, keywords, activeSortBy),
    removeFilter: (data, keywords, activeSortBy) =>
      chosenFilter.actions.removeFilter(data, keywords, activeSortBy)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FitlerOption);
